import ImageConverterTemplate from "../components/ImageConverterTemplate";
export default function ConvertJpgToTiff() {
  return <ImageConverterTemplate sourceFormat="JPG" targetFormat="TIFF" acceptTypes=".jpg,.jpeg,image/jpeg" slug="convert-jpg-to-tiff" gradientColors="from-pink-500 to-rose-600" accentColor="pink" />;
}
